import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useGetMenusDataQuery } from "../../../redux/services/internal/apiHome";
import SearchComponent from "../../Container/Components/SearchComponent";
import Loader from "../../Container/Components/Loader";

const MainMenus = ({ benchId }) => {
  const { data: fetchMenus = {}, isLoading: isMenuLoading } =
    useGetMenusDataQuery(benchId);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggleMainNav = () => {
    setIsCollapsed(!isCollapsed);
  };
  if (isMenuLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="menu-area">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="menu-sec ">
                <nav className="navbar navbar-expand-lg custom-navbar  wow fadeInUp ">
                  <div className="container-fluid px-0">
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                      onClick={toggleMainNav}
                    >
                      <i
                        className={`fa-solid  ${
                          !isCollapsed ? "fa-xmark" : "fa-bars"
                        }`}
                      ></i>
                    </button>
                    <div
                      className={`collapse navbar-collapse custom-nav ${
                        !isCollapsed ? "show" : ""
                      }`}
                      id="navbarSupportedContent"
                    >
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                          <Link className="nav-link" aria-current="page" to="">
                            <i className="fa-solid fa-house"></i>
                          </Link>
                        </li>
                        {/* Dynamically rendered menu items from API data */}
                        {fetchMenus.status &&
                          fetchMenus.data &&
                          fetchMenus.data.length > 0 &&
                          fetchMenus.data.map((menu, index) =>
                            menu.sub_pages.length === 0 ? (
                              <li className="nav-item" key={index}>
                                <NavLink className="nav-link" to={menu.slug}>
                                  {menu.title}
                                </NavLink>
                              </li>
                            ) : (
                              <li className="nav-item dropdown" key={index}>
                                <NavLink
                                  className="nav-link dropdown-toggle"
                                  to="about-us"
                                >
                                  {menu.title}
                                </NavLink>
                                <ul className="submenus">
                                  {[...menu.sub_pages]
                                    .sort((a, b) => a.short_id - b.short_id)
                                    .map((submenu, i) => (
                                      <li key={i} className="nav-item">
                                        <Link
                                          className="nav-link"
                                          to={`${submenu.slug}`}
                                        >
                                          {submenu.title}
                                        </Link>
                                      </li>
                                    ))}
                                </ul>
                              </li>
                            )
                          )}
                        <li className="nav-item">
                          <Link className="nav-link" to="present-members">
                            Present Members
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link className="nav-link dropdown-toggle" to="#">
                            Services
                          </Link>
                          <ul className="submenus">
                            <li className="nav-item">
                              <Link
                                to={`case-management-system/cause-list`}
                                className="nav-link"
                              >
                                Cause List
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to={`case-management-system/case-status`}
                                className="nav-link"
                              >
                                Case Status
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to={`case-management-system/judgement`}
                                className="nav-link"
                              >
                                Judgement
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
                <SearchComponent benchId={benchId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainMenus;
